// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nul[data-v-19f1000e] {\n    list-style-type: none;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\nul li[data-v-19f1000e]:hover {\n    opacity: 0.7;\n}\n.icon-container[data-v-19f1000e] {\n    width: 60px;\n    height: 60px;\n}\n.icon-container-mobile[data-v-19f1000e] {\n    width: 55px;\n    height: 55px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
